// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1HsBR","content":"Consent_content___S4Ag","footer":"Consent_footer__3PmN1"};